/** One cap per bounded GraphQL list root: max(default, 2 × the largest per-org count measured on prod 2026-10-05). */
export const LIST_CAPS = {
  automations: 500,
  businessEntities: 6_000,
  buySellOrders: 5_000,
  commodities: 5_000,
  commodityLabels: 5_000,
  commoditySizes: 5_000,
  commodityStyles: 5_000,
  commodityUnits: 5_000,
  conversations: 20,
  conversationsForOrganization: 200,
  distinctValueOptions: 5_000,
  documentClasses: 100,
  ediProductMappings: 5_000,
  expenseTypes: 5_000,
  growerProducts: 11_000,
  guestMemberships: 5_000,
  inventoryTransfers: 5_000,
  labelAttachments: 78_000,
  lineItems: 5_000,
  lots: 5_000,
  memberships: 5_000,
  places: 6_000,
  productionRuns: 57_000,
  products: 20_000,
  purchaseOrders: 17_000,
  salesOrders: 69_000,
  thirdPartyIntegrations: 500,
  users: 5_000,
  warehouseLocations: 5_000,
  warehouses: 5_000,
} as const;

export type ListRoot = keyof typeof LIST_CAPS;
